<template>
  <FriedButton data-external="bank-id-sweden-open-app-button" @click="() => bankIdAppLink.click()">
    <template #leftIcon>
      <FriedIcon icon="share" />
    </template>
    {{ t('cr_open_bankid') }}
  </FriedButton>
  <a ref="bankIdAppLink" class="bank-id-app-link" :href="appUrl" referrerPolicy="origin" />
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps<{
  appUrl: string;
}>();

const { t } = useI18n();
const bankIdAppLink = ref<HTMLAnchorElement | null>(null);
</script>
<style lang="scss" scoped>
.bank-id-app-link {
  display: none;
}
</style>
